import {Carousel} from '../store/models/Carousel';

export const isCollectionNameInCollectionsList = (collectionsList?: Carousel[], collectionName?: string | null): boolean =>
  Boolean(collectionsList?.length && collectionName && collectionsList.some(collection => collection.name.toLowerCase() === collectionName));
